<template>
    <div class="admin-login-content">
        <div class="admin-login-box">
            <div class="title">
                后台管理员登录
            </div>

            <div class="form">
                <div class="account">
                    <label>账号</label>
                    <el-input v-model="account" placeholder="请输入账号" />
                </div>

                <div class="password">
                    <label>密码</label>
                    <el-input v-model="password" placeholder="请输入密码" type="password"/>
                </div>

                <div class="submit">
                     <el-button type="primary" round size="large" class="w-full" @click="onLogin">登录</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { Api } from '@/http/Api';
import { ResponseCode } from '@/http/ResponseCode';
import { router } from '@/router';
import { Action } from '@/typeDefine/CommonTypes';
import { BaseResponse } from '@/typeDefine/HttpResponseType';
import { UtilMethods } from '@/util/UtilMethods';
import { ref, Ref } from 'vue';

//账号
const account: Ref<string> = ref('')

//密码
const password: Ref<string> = ref('')

const onLogin: Action = async () => {
    const response: BaseResponse = await Api.instance.adminLogin({
        account: account.value,
        password: password.value
    })

    UtilMethods.showMessageToast(response)

    if(response.code === ResponseCode.OK) {
        router.replace({
            name: 'adminIndex'
        })
    }
}
</script>

<style lang="css" scoped>
.admin-login-content {
    width: 100%;
    height: 100vh;
    background: linear-gradient(to bottom, #A3ABBC, #E1E4E9 );
}
.admin-login-content .admin-login-box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 30%;
    padding: 50px;
    background-color: #fff;
    border-radius: 10px;
}

.admin-login-box .title{
    margin-bottom: 30px;
    font-size: 24px;
    font-weight: bold;
}
.admin-login-box .form .account,
.admin-login-box .form .password {
    margin-bottom: 20px;
}

.admin-login-box .form .account label,
.admin-login-box .form .password label {
    display: inline-block;
    margin-bottom: 10px;
}

.admin-login-box .form .submit{
    width: 100%;
    margin: 0 auto;
}

@media (max-width: 1000px) {
    .admin-login-content .admin-login-box{
        width: 40%;
    }
}

@media (max-width: 768px) {
    .admin-login-content .admin-login-box{
        width: 60%;
    }
}
</style>